<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <top-right-absolute>
        <v-btn flat icon color="grey" @click="edit = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </top-right-absolute>
      <div style="position: absolute; left: 3px; top: 3px">
        <v-btn
          flat
          icon
          :color="rate.active ? 'green lighten-3' : 'red lighten-3'"
          @click="edit = true"
        >
          <v-icon v-if="rate.active">check_circle</v-icon>
          <v-icon v-else>highlight_off</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <router-link router :to="{ name: 'site', query: {fid: rate.id} }" tag="div">
        <v-card-text>
          <div class="pb-3">
            <h5 class="subheading font-weight-regular text-capitalize">{{rate.name}}</h5>
            <div class="grey--text text-capitalize">
              <span class="clickable">{{rate.client.name}}</span>
            </div>
          </div>
          <div class="pb-4">
            <h5
              class="subheading font-weight-regular grey--text text--darken-1"
            >{{rate.contactEmail}}</h5>
          </div>
        </v-card-text>
      </router-link>

      <!--  CARD ACTIONS -->
      <v-card-actions>
        <div class="grey--text ml-2">
          <v-badge overlap :color="$store.state.global.pages.site.color">
            <v-icon large>map</v-icon>
            <span slot="badge">{{rate.siteCount}}</span>
          </v-badge>
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>

      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <!-- CARD FOOTER -->
      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :time="updatedAt" updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>
      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog v-model="edit" max-width="700px" @keydown.esc="edit = false">
      <edit-rate :rate="rate" @close="edit = false"></edit-rate>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{rate.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteRate(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditRate from "@/components/rates/editRate";
export default {
  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteRate() {
      var rate = this.rate;
      RateService.deleteRate(rate.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("rates/deleteRate", rate);
          this.snack({ text: "Rate was deleted!", color: "yellow" });
        })
        .catch(err => {
          this.snackError();
        });
    }
  },
  props: {
    rate: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.rate.name.charCodeAt(0));
    },
    letter() {
      return this.rate.name.charAt(0);
    },
    updatedAt() {
      return Date.parse(this.rate.updatedAt);
    }
  },
  components: {
    EditRate
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
